import BookingRoleWorkerSource from '@/models/BookingRoleWorkers/BookingRoleWorkerSource';

export default class CreateBookingRoleWorkerShiftsRequest {
    bookingRoleWorkerId: string;
    shiftIds: string[];
    sendWorkerOfferNotification: boolean;
}